// extracted by css-extract-rspack-plugin
module.exports =  {"custom_scrollbar":"NotificationPreview_custom_scrollbar__En6pS"};